import { Component, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { UsersService } from 'src/app/users/src/users.service';
import { ActivatedRoute } from '@angular/router';
import { IRequestEvent, EActionEvent } from 'src/app/users/src/users.model';
import { DataHelper, DialogService } from 'src/app/core';
import { TrainingService } from 'src/app/training/src/training.service';
import { EClass } from 'src/app/model';

@Component({
	templateUrl: './tpl/dashboard.html',
	styleUrls: ['./tpl/dashboard.scss']
})
export class Dashboard implements OnInit {
	userSubscription: Subscription;
	trainingSubscription: Subscription;
	user;
	nbSeance: number;
	nbExos: number;
	constructor(private usersService: UsersService,
		private trainingService: TrainingService,
		private dialog: DialogService,
		private route: ActivatedRoute) { }

	ngOnInit(): void {
		let id;
		this.userSubscription = this.usersService.getUserEvent().subscribe(
			(obj: IRequestEvent) => {
				this._resolveEvent(obj)
			}
		)
		this.trainingSubscription = this.trainingService.getTrainingEvent().subscribe(
			(obj: IRequestEvent) => {
				this._resolveEvent(obj)
			}
		)
		if (id = this.route.snapshot.params['id']) {
			this.usersService.getUser(id);
		} else {
			this.usersService.getUser('1');
		}
	}

	ngOnDestroy() {
		this.userSubscription.unsubscribe();
		this.trainingSubscription.unsubscribe();
	}

	private _insertTraining(training: any): void {
		this.user.exercice.push(training)
		DataHelper.sortBy(this.user.exercice, 'date', true)
	}
	private _getInfos() {
		this.nbSeance = DataHelper.groupBy(this.user.exercice, 'date').length;
		this.nbExos = DataHelper.groupBy(this.user.exercice, 'exercice_id').length;
	}
	private _resolveEvent(e: IRequestEvent): void {
		switch (e.action) {
			case EActionEvent.FIND:
			case EActionEvent.GET:
				this.user = e.data
				DataHelper.sortBy(this.user.exercice, 'date', true)
				break;
			case EActionEvent.CREATE:
				if (e.class === EClass.TRAINING)
					this._insertTraining(e.data);
			case EActionEvent.UPDATE:
				if (e.class === EClass.TRAINING && e.data != null)
					this._updateTraining(e.data);
				break;
			case EActionEvent.DELETE:
				if (e.class === EClass.TRAINING && e.data != null)
					this._deleteTraining(e.data);
				break;
		}
		this._getInfos()
		this.dialog.closeDialog()
	}
	_deleteTraining(id: any) {
		let index = this.user.exercice.findIndex(t => t.id == id)
		this.user.exercice.splice(index, 1)
	}
	_updateTraining(training: any): void {
		let index = this.user.exercice.findIndex(t => t.id == training.id)
		this.user.exercice[index] = training
	}
}
